import React, { FC } from 'react';

import Organization from 'entities/organization/model';

interface CompanyLinkProps {
  company: Organization;
}

const CompanyLink: FC<CompanyLinkProps> = ({ company }) => <>{company.name}</>;

export default CompanyLink;
